




























































































import { Component, Model, Prop, Vue, Watch } from "vue-property-decorator";
// import * as api from "../../api/index";
import axios from "axios";
import { fetch as request, getCookie, PUBLIC_ASSETS_PATH, setCookie } from "@szgc/plt-core-v2";
import Layout from "../../package/widgets/SelectWidget/object/layout.vue";

@Component({
  name: "UploadComponent",
  components: { Layout }
})
export default class UploadComponent extends Vue {
  @Model("change")
  fileIds!: any;

  @Prop()
  readonly!: boolean;

  @Prop({ default: false })
  multiple!: boolean;

  @Prop({ default: false })
  previewEnable!: boolean;

  @Prop({ default: true })
  downloadEnable!: boolean;

  @Prop({ default: "系统默认" })
  previewUrl!: string;

  @Prop({ default: "系统默认" })
  downloadUrl!: string;

  @Prop()
  notLimitSize!: boolean;

  @Prop({ default: 1024 })
  maxSize!: number;

  @Prop({ default: [] })
  accept!: string[];

  @Prop({ default: 1 })
  maxCount!: number;

  @Prop({ default: "" })
  path!: string;

  @Prop({ default: "" })
  ext!: { [prop: string]: any } | { [prop: string]: any }[];

  @Prop({ default: false })
  onlineEnable!: boolean;

  private processKey: number = 0;
  private prefix = getCookie("plt-api-route") || "";
  private customColors = [
    { color: "var(--szgc-element-danger-color)", percentage: 20 },
    { color: "var(--szgc-element-warning-color)", percentage: 40 },
    { color: "var(--szgc-element-primary-light-5)", percentage: 60 },
    { color: "var(--szgc-element-primary)", percentage: 80 },
    { color: "var(--szgc-element-success-color)", percentage: 100 }
  ];

  private file: {
    id?: string;
    name?: string;
    url?: string;
    downUrl?: string;
    preview?: boolean;
    loadProgress?: number;
  }[] = [];

  private timer!: number;

  private visible: boolean = false;
  private fileUrl: string = "";
  private srcList: any[] = [];
  private nowAttachment: any = null;
  private onlineVisible: boolean = false;
  private onlineUrl: string = "";
  private onlineUrlBase: string = "";

  isPreviewAble(item: any) {
    if (!this.previewEnable) return false;
    if (!item.preview) return false;
    const imgExt = ["png", "jpg", "jpeg", "gif", "svg"];

    const ext = item.url.match(/\.\w+$/);
    if (!ext) return false;

    const et = ext[0].replace(".", "");

    if (imgExt.indexOf(et) >= 0) {
      return true;
    } else if (item.pdfUrl) {
      return true;
    }
    return false;
  }

  isOnlineAble(item: any) {
    if (!item.onlineEnable) return false;
    const fileName = item.name.toLowerCase();
    return (
      /\.doc$/.test(fileName) ||
      /\.docx$/.test(fileName) ||
      /\.xlsx$/.test(fileName) ||
      /\.xls$/.test(fileName)
    );
  }

  /*通过iframe打开在线编辑*/
  async handleOline(item: any) {
    //先去配置接口请求iframe地址，接口返回地址后再改变onlineUrl。需要参数附件id，token和origin。
    const { jwtKey, tokenValue } = await this.getPltToken();
    this.nowAttachment = item;
    const { downUrl, name } = item;
    this.onlineUrl = `${this.onlineUrlBase}?fileUrl=${window.location.origin}${encodeURIComponent(
      downUrl
    )}&fileName=${name}&token=${tokenValue}&jwtKey=${jwtKey}`;
    this.onlineVisible = true;
    window.onmessage = (e: any) => this.messageLister(e);
  }

  beforeUpload(file: any) {
    const accept = this.accept;
    if (accept.length && !accept.join(",").includes(file.name.match(/\..*$/g)[0])) {
      return `请上传正确类型的文件（文件类型后缀以${accept.join(",")}结尾）`;
    }

    if (!this.notLimitSize && file.size / 1024 > this.maxSize) {
      return `上传的文件超过${this.maxSize}kb`;
    }

    return true;
  }

  overCount() {
    this.$message.error(`只能上传不超过${this.maxCount}个文件`);
  }

  /*预览*/
  async handlePreview(item: any) {
    if (item.pdfUrl) {
      this.pdfView(item.pdfUrl);
    } else {
      const filePath: string = item.url;
      const index: number = filePath.lastIndexOf(".");
      const ext: string = filePath.substr(index + 1);
      const ifImage: boolean =
        ["png", "jpg", "jpeg", "gif", "svg"].indexOf(ext.toLowerCase()) !== -1;
      const ifPdf: boolean = ["pdf"].indexOf(ext.toLowerCase()) !== -1;
      if (ifImage) {
        //是图片
        this.fileUrl = item.url;
        this.srcList = [item.url];
        (this.$refs.preview as any).showViewer = true;
      } else if (ifPdf) {
        //是pdf
        this.pdfView(item.url);
      } else {
        //都不是,直接下载
        this.handleDownLoad(item.downUrl, item, true);
      }
    }
  }

  /*下载*/
  async handleDownLoad(url: string, item: any, flag: boolean) {
    if (flag) {
      let confirm;
      try {
        confirm = await this.$confirm(
          `只支持图片和PDF的预览，其它格式点击确定后将直接下载，确认下载?`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            closeOnClickModal: false,
            type: "warning"
          }
        );
      } catch (e) {
        confirm = null;
      }
      if (!confirm) {
        return false;
      }
    }
    const a = document.createElement("a");
    a.href = url;
    a.download = item.name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  /*获取token*/
  async getPltToken() {
    const PLT_JWT_U_NAME = "PLT_JWT_U";
    let jwtKey = getCookie(PLT_JWT_U_NAME);
    if (!jwtKey) {
      const result = await request.get("/secure/current");
      if (result.success) {
        jwtKey = result.data.jwtKey as string;
        setCookie(PLT_JWT_U_NAME, jwtKey);
      } else {
        return {
          jwtKey: "",
          tokenValue: ""
        };
      }
    }
    return {
      jwtKey: jwtKey,
      tokenValue: getCookie(jwtKey) || ""
    };
  }

  /*pdf预览*/
  async pdfView(url: string) {
    const token = await this.getPltToken();
    const params = new URLSearchParams();
    params.append(token.jwtKey, token.tokenValue);
    const fileUrl = encodeURIComponent(url + "?" + params.toString());
    // 查看附件地址
    this.fileUrl = PUBLIC_ASSETS_PATH + "pdfjs/web/viewer.html?file=" + fileUrl;
    this.visible = true;
  }

  deleteFile(index: number) {
    this.file.splice(index, 1);
    this.$emit(
      "change",
      this.file
        .map((i) => i?.id)
        .filter(Boolean)
        .join()
    );
  }
  async getOnlineUrl() {
    // try {
    //   const { success, data } = await request.get(
    //     "/api/system/customized/sys-configs/ONLINE_OFFICE_URL"
    //   );
    //   if (success && data.content) {
    //     this.onlineUrlBase = data.content;
    //   }
    // } catch (e) {
    //   console.log("获取在线编辑基础地址失败", e);
    // }
  }
  async getAttachmentInfo() {
    let arr: {
      id?: string;
      name?: string;
      url?: string;
      downUrl?: string;
      preview?: string;
      onlineEnable?: boolean;
      loadProgress?: number;
    }[];

    if (!this.ext || !Object.keys(this.ext).length) arr = [];
    else {
      arr = (Array.isArray(this.ext) ? this.ext : [this.ext]).map((i: any) => {
        const f = {
          id: i.attId,
          name: i.fileName,
          url: i.requestRelativeUri,
          downUrl: i.requestRelativeUri,
          pdfUrl: i.pdfRequestRelativeUri || "",
          preview: false,
          onlineEnable: this.onlineEnable,
          loadProgress: 100
        };

        if (i.requestRelativeUri) {
          const index: number = i.requestRelativeUri.lastIndexOf(".");
          const ext: string = i.requestRelativeUri.substr(index + 1);
          f.preview = ["png", "jpg", "jpeg", "gif", "svg", "pdf"].indexOf(ext.toLowerCase()) !== -1;
          if (f.pdfUrl) {
            f.preview = true;
          }
        }

        if (this.previewUrl !== "系统默认") {
          f.url = this.previewUrl.replaceAll(/\$file/g, f.id);
        }
        if (this.downloadUrl !== "系统默认") {
          f.downUrl = this.downloadUrl.replaceAll(/\$file/g, f.id);
        }

        return f;
      }) as any;
    }
    this.file = arr as any;
  }

  fileSelectChange(f: any, fList: any[]) {
    this.timer && clearTimeout(this.timer);

    this.timer = setTimeout(() => {
      if (this.file.length + fList.length > this.maxCount) {
        (this.$refs.elUpload as any).clearFiles();
        return this.$message.error(`只能上传不超过${this.maxCount}个文件`);
      }

      let canUpload: any;
      const flag = fList.every((i: any) => {
        canUpload = this.beforeUpload(i.raw);

        return canUpload === true;
      });

      if (!flag) {
        (this.$refs.elUpload as any).clearFiles();
        return this.$message.error(canUpload);
      }
      const formData = new FormData();
      fList.forEach((f: any) => {
        formData.append(this.multiple ? "files" : "file", f.raw);
      });
      this.customUpload(formData, fList);
    }, 500);
  }

  async customUpload(formData: FormData, fileList: any) {
    try {
      const { $attrs, path } = this;
      formData.append("propertyNamePath", path);
      formData.append("reqToken", $attrs.reqToken);
      // const { success, data } = await api[
      //   this.multiple ? "uploadMultiAttachment" : "uploadSingleAttachment"
      // ]($attrs.pacId, $attrs.businessId, formData);
      const url = `${this.prefix}/api/appproc/packages/${$attrs.pacId}/matters/${
        $attrs.businessId
      }/attachments/${this.multiple ? "multi" : "single"}-upload`;

      let cancel: () => void;
      const { CancelToken } = axios;
      const cancleFn = new CancelToken((c) => {
        //c是一个函数，调用c就可以关闭本次请求
        cancel = c;
      });

      const fileMap: any = {};
      (this.$refs.elUpload as any).clearFiles();
      let processKey = ++this.processKey;
      const list = (Array.isArray(fileList) ? fileList : [fileList]).reduce((prev, i: any) => {
        const f = {
          id: null,
          name: i.name,
          url: null,
          downUrl: null,
          preview: false,
          onlineEnable: false,
          uid: i.uid,
          loadProgress: 0,
          progressStatus: "warning",
          cancel: cancel,
          processKey
        };
        prev.push(f);
        fileMap[i.name] = f;
        return prev;
      }, []);
      this.file.push(...list);

      const requestaxios = axios.create({
        baseURL: "/"
        // timeout: 1000
      });
      try {
        const {
          data: { success, data }
        } = await requestaxios({
          method: "POST",
          headers: { "Content-Type": "multipart/form-data" },
          url,
          data: formData,
          cancelToken: cancleFn,
          onUploadProgress: (node: any) => {
            let tempProgress = node.loaded / node.total; //上传进度
            const loadProgress = parseInt(`${tempProgress * 100}`);
            list.forEach((item: any) => {
              item.loadProgress = loadProgress;
              item.progressStatus = loadProgress < 100 ? "warning" : "success";
            });
            if (tempProgress === 1) {
              list.forEach((item: any) => {
                item.progressFlag = false;
              });
            }
          }
        });

        if (!success) {
          list.forEach((item: any) => {
            item.progressStatus = "exception";
          });
          return this.$message.error("上传失败");
        }

        (Array.isArray(data) ? data : [data]).forEach((i: any) => {
          const f: any = {
            id: i.fileId,
            name: i.name,
            url: i.requestUri,
            downUrl: i.requestUri,
            preview: false,
            onlineEnable: this.onlineEnable
          };

          if (i.requestRelativeUri) {
            const index: number = i.requestRelativeUri.lastIndexOf(".");
            const ext: string = i.requestRelativeUri.substr(index + 1);
            f.preview =
              ["png", "jpg", "jpeg", "gif", "svg", "pdf"].indexOf(ext.toLowerCase()) !== -1;
          }

          if (this.previewUrl !== "系统默认") {
            f.url = this.previewUrl.replaceAll(/\$file/g, f.id);
          }
          if (this.downloadUrl !== "系统默认") {
            f.downUrl = this.downloadUrl.replaceAll(/\$file/g, f.id);
          }
          const item = fileMap[i.name];
          Object.keys(f).forEach((key) => {
            this.$set(item, key, f[key]);
          });

          // this.file.push(f);
        });

        this.$emit("change", this.file.map((i) => i?.id).join());
      } catch (error) {
        console.error(error);
        list.forEach((item: any) => {
          item.progressStatus = "exception";
        });
      }
    } catch (error) {
      console.error(error);
      (this.$refs.elUpload as any).clearFiles();
      this.$message.error("上传异常");
    }
  }

  format(item: any, percentage: number) {
    if (item.progressStatus === "exception") {
      return "失败";
    }
    return percentage === 100 ? "成功" : `${percentage}%`;
  }

  cancelProcess(file: any) {
    if (file.cancel) {
      file.cancel();
      this.file = this.file.filter((item: any) => item.processKey !== file.processKey);

      this.$emit(
        "change",
        this.file
          .map((i) => i?.id)
          .filter(Boolean)
          .join()
      );
    }
  }

  async uploadFileByUrl(fileHookUrl: string) {
    try {
      const nowAttachment = this.nowAttachment;
      const { success, data } = await request.post("/api/attachments/single-hook-upload", {
        data: {
          fileHookUrl,
          originalFilename: nowAttachment.name
        }
      });
      if (!success) {
        return this.$message.error("上传附件失败");
      }
      nowAttachment.id = data.fileId;
      nowAttachment.downUrl = data.requestUri;
      this.$emit("change", this.file.map((i) => i?.id).join());
      this.onlineVisible = false;
    } catch (e) {
      console.log("上传附件失败", e);
    }
  }

  messageLister(e: any) {
    try {
      const { type, data } = e.data;
      if (type === "save" && data) {
        // 监听iframe 编辑完成后上传文件
        this.uploadFileByUrl(data);
      }
    } catch (e) {
      console.log("messageLister:", e);
    }
  }
  @Watch("ext", { immediate: true, deep: true })
  extChange() {
    this.getAttachmentInfo();
  }
  // mounted() {
  //   this.getAttachmentInfo();
  //   this.getOnlineUrl();
  // }
}
